// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"Code_codeContainer__2LMtG"};